import React from 'react';
import styles from './MessagesList.module.css';
import cn from 'classnames';
import { iconsSourcesCustom } from '../../helpers/icons';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { formatPhoneNumber } from '../../helpers/titreHelper';

import plashka1 from '../../assets/images/plashka1.png';
import plashka2 from '../../assets/images/plashka2.png';

const MessagesList = ({
  className,
  advtInfo,
  messages,
  setDelay,
  messagesWrapper,
  currentMessageRef,
  phoneNumberFontSize,
  titleFontSize,
  authorFontSize,
  msgFontSize,
  user,
  variantPlashka,
}) => {
  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ');
  return (
    <div
      className={cn(styles.wrapper, className)}
      style={{
        backgroundImage: `url(${variantPlashka === '1' ? plashka1 : plashka2})`,
      }}
    >
      <div className={styles.container}>
        {(advtInfo.label || phoneNumberFormat || advtInfo.socials) && (
          <div className={styles.infoBlock}>
            <div className={styles.info}>
              <div className={styles.desc}>
                <div className={styles.socials}>
                  {advtInfo.socials &&
                    advtInfo.socials.map((item) => (
                      <div key={item} className={styles.icon}>
                        <img src={iconsSourcesCustom[item]} alt={item} />
                      </div>
                    ))}
                </div>
              </div>

              <div className={styles.textInfo}>
                <div
                  className={styles.title}
                  style={{ fontSize: `${titleFontSize}rem` }}
                >
                  {advtInfo.label}
                </div>

                <div
                  className={styles.number}
                  style={{ fontSize: `${phoneNumberFontSize}rem` }}
                >
                  {phoneNumberFormat}
                </div>
              </div>
            </div>
          </div>
        )}
        <TransitionGroup className={styles.messages} appear={true}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={3000}
                classNames="position"
              >
                <Message
                  key={item.id}
                  message={item.message}
                  titrTag={item.titrTag}
                  setDelay={setDelay}
                  messagesWrapper={messagesWrapper}
                  currentMessageRef={currentMessageRef}
                  authorFontSize={authorFontSize}
                  msgFontSize={msgFontSize}
                  user={user}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>
    </div>
  );
};
export default React.memo(MessagesList);
